import React from "react";
import type { KgMetricIconProps } from "./KgMetricIcon.types";

/** Gauge icon for metric nodes (Figma `gauge` — panel header 14px, tabs 16px). */
export const KgMetricIcon: React.FC<KgMetricIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M8 9.33268L10.6667 6.66602"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.22634 12.6663C1.64115 11.6529 1.33305 10.5032 1.33301 9.33294C1.33296 8.16266 1.64098 7.013 2.22609 5.99949C2.8112 4.98599 3.65279 4.14437 4.66627 3.55922C5.67975 2.97407 6.8294 2.66602 7.99967 2.66602C9.16995 2.66602 10.3196 2.97407 11.3331 3.55922C12.3466 4.14437 13.1882 4.98599 13.7733 5.99949C14.3584 7.013 14.6664 8.16266 14.6663 9.33294C14.6663 10.5032 14.3582 11.6529 13.773 12.6663"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgMetricIcon;
